export default __webpack_public_path__ + "static/richard-girges-5493c946fb5baf4869c19cbc51a66710.png";